import { useState,useEffect } from "react"
import { Container, Grid, Typography, Box } from "@mui/material";
import { GlobalMessagesWidget } from "./GlobalMessagesWidget";
import { NewConnectionsWidget } from "./NewConnectionsWidget";
import { ContactsUpdatesWidget } from "./ContactsUpdatesWidget";
import { OpportunitiesOtherUsersWidget } from "./OpportunitiesOtherUsersWidget";
import { OffersSummaryWidget } from "./OffersSummaryWidget";
import PropertyViewingsWidget from "./PropertyViewingsWidget"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { InquiriesWidget } from "./InquiriesWidget";
import { FavoritesWidget } from "./FavoritesWidget";
import { MarketplaceOpportunitiesWidget } from "./MarketplaceOpportunitiesWidget";
import { DealsProgressWidget } from "./DealsProgressWidget";
import { UpcomingEventsWidget } from "./UpcomingEventsWidget";
import { CurrentTasksWidget } from "./CurrentTasksWidget";
import { DealTaskCommentsWidget } from "./DealTaskCommentsWidget";
import LoaderWithLinearProgress from "../../app/components/LoaderWithLinearProgress";

import {useAppSelector} from "../../app/store/configureStore";
import {useNavigate} from "react-router-dom";

const textColor = "#0d2561";
export default function Dashboard() {
  const [loading, setLoading] = useState(true);

  const {user} = useAppSelector((state) => state.account);
  const navigate = useNavigate();

  if (!user) {
    navigate("/login");
  }

  if (user && !user?.isConfirmed) {
    navigate("/create-profile");
  }
  useEffect(() => {
  
      setLoading(false);
  }, []) // Run only once on mount
    

  if (loading) return <LoaderWithLinearProgress />;
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h5" fontWeight={600} color={textColor} gutterBottom>
        Dashboard (Current / Immediate)
      </Typography>

      <Grid container spacing={4}>
        {/* Column 1 - Partners / Connections */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" fontWeight={500} mb={2}>
            Partners / Connections
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <NewConnectionsWidget />
            <GlobalMessagesWidget />
            <ContactsUpdatesWidget />
            <OpportunitiesOtherUsersWidget />
          </Box>
        </Grid>

        {/* Column 2 - Marketplace Activities */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" fontWeight={500} mb={2}>
            Marketplace Activities
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <OffersSummaryWidget />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <PropertyViewingsWidget />
            </LocalizationProvider>
            <InquiriesWidget />
            <FavoritesWidget />
            <MarketplaceOpportunitiesWidget />

            

          </Box>
        </Grid>

        {/* Column 3 - My Deals Activities */}
        <Grid item xs={12} md={4}>
          <Typography variant="h6" fontWeight={500} mb={2}>
            My Deals Activities
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <DealsProgressWidget />
            <UpcomingEventsWidget />
            <CurrentTasksWidget />
            <DealTaskCommentsWidget />

            
            
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}
